export default "__VITE_ASSET__GcXaPwH5__"